import "./styles/global.scss";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { NamecpaceContext, Namespace } from "@zkt/eb-utility";
import App from "./app";
import { startup } from "./init";

startup();

ReactDOM.render(
  <BrowserRouter>
    <NamecpaceContext.Provider value={Namespace.GLOBAL}>
      <App />
    </NamecpaceContext.Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
